import {Injectable} from "@angular/core";

var SockJs = require("sockjs-client");
var Stomp = require("stompjs");

@Injectable()
export class WebSocketService {
    private storm: any;
   
    public connect() {
        let socket=new SockJs("http://localhost:7890/socket", null,{
            headers: {
              'Access-Control-Allow-Origin':'*',
              "secure": false
            }
          });
        //let socket = new SockJs(`http://localhost:8081/socket`);
        let stompClient = Stomp.over(socket);
        return stompClient;
    }
   
}